import React, { useState } from 'react';
import Header from './components/Header.jsx';
import Sidebar from './components/Sidebar.jsx';
import Home from './components/Home.jsx';
import PageContent from './components/PageContent.jsx';
import GlitterCanvas from './components/GlitterCanvas.jsx';
import Login from './components/Login.jsx';
import SignUp from './components/SignUp.jsx';
import './styles/App.css';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState(null);
  const [showSignUp, setShowSignUp] = useState(false);
  const [glitterPosition, setGlitterPosition] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClick = (pageId, position) => {
    setCurrentPage(pageId);
    setShowSignUp(false);
    setGlitterPosition(position);
    setTimeout(() => setGlitterPosition(null), 100);
  };

  const handleHomeClick = (position) => {
    setCurrentPage(null);
    setShowSignUp(false);
    setGlitterPosition(position);
    setTimeout(() => setGlitterPosition(null), 100);
  };

  const handleSignUp = () => {
    setCurrentPage(null);
    setShowSignUp(true);
  };

  const handleLogin = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    setCurrentPage(null);
  };

  return (
    <div className="App">
      <Header 
        isMenuOpen={isMenuOpen} 
        onMenuToggle={toggleMenu}
        onGlitter={setGlitterPosition}
        user={user}
        onLogin={handleLogin}
        onLogout={handleLogout}
        onSignUp={handleSignUp}
      />
      <Sidebar 
        isOpen={isMenuOpen && !showSignUp} 
        currentPage={currentPage}
        onMenuClick={handleMenuClick}
        isAuthenticated={isAuthenticated}
        userRole={user?.role}
      />
      <main className={`main-content ${!isMenuOpen ? 'expanded' : ''}`}>
        {showSignUp ? (
          <SignUp onBack={() => setShowSignUp(false)} />
        ) : currentPage ? (
          <PageContent pageId={currentPage} />
        ) : (
          <Home onLogoClick={handleHomeClick} />
        )}
      </main>
      {glitterPosition && (
        <GlitterCanvas x={glitterPosition.x} y={glitterPosition.y} />
      )}
    </div>
  );
}

export default App;
